import api from "./client";

export async function getMyProfile() {
    try {
        return await api("/profile/me");
    } catch (e) {
        if (e.status === 404) return null;
        throw e;
    }
}

export function upsertMyProfile(payload) {
    return api("/profile/me", { method: "PUT", body: payload });
}

export function patchMyProfile(payload) {
    return api("/profile/me", { method: "PATCH", body: payload });
}

export function deleteMyProfile() {
    return api("/profile/me", { method: "DELETE" });
}
